import dayjs from "dayjs";
import Loading from 'quasar/src/plugins/loading/Loading.js';import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';
import { computed, defineComponent, reactive, ref, watch } from "vue";
import { AttachedFile, Taikyo } from "~/api/data/TaikyoNotificationEntity";
import { MsgBox } from "~/components/MsgBox";
import { Log } from "~/extensions/utils";
import { createAddress } from "~/extensions/utils/AddressHelper";
import { KeyReturnAdrKb, KeyReturnNameKb, RenrakuKb, TaikyoRiyuKb } from "~/extensions/utils/DefineTypes";
import { validateSelectedFiles } from "~/pages/taikyo/notification/Models/TaikyoNotificationFileHelper";
import { clearContactFields, clearReturnAddressFields, updateKaiyakuYmd, updateKeyReturnDateTime } from "~/pages/taikyo/notification/Models/TaikyoFormHelper";
import { store } from "~/pages/taikyo/store/TaikyoStore";
import { myPageStore } from "~/store/MyPageStore";
import { TaikyoNotificationViewModel } from "../Models/TaikyoNotificationViewModel";
import { TaikyoValidator } from "../Models/TaikyoNotificationInputValidator";
const log = Log.create("TaikyoNotificationCard");
export default defineComponent({
    name: "taikyoNotificationCard",
    emit: ["remove"],
    props: {
        row: {
            type: Taikyo,
            required: true
        },
        taikyoForInput: {
            type: Object,
            required: true
        },
        desiredDatePrecautions: {
            type: Object,
            required: true
        }
    },
    setup(props, { expose, emit }) {
        const $q = useQuasar();
        const isMultipleKeiyaku = computed(() => store.taikyoNotificationEntity.taikyoList.filter(x => !x.isDeleted).length > 1);
        const isMMA = myPageStore.personal.isMma;
        // 入力値の検証と希望日時メッセージ
        const viewModel = new TaikyoNotificationViewModel(store.taikyoNotificationEntity, props.taikyoForInput);
        const validators = reactive(new Map());
        const getValidator = (row) => {
            if (!validators.has(row.taikyoNo)) {
                validators.set(row.taikyoNo, new TaikyoValidator(viewModel, row, props.taikyoForInput));
            }
            return validators.get(row.taikyoNo);
        };
        // 希望日時の注意事項
        const desiredDateMessage = computed(() => props.desiredDatePrecautions.precaution);
        const desiredDateEntryMessage = computed(() => props.desiredDatePrecautions.entryPrecaution);
        // ダイアログとファイル入力
        const dialogOpenHason = ref(false);
        const dialogOpenOther = ref(false);
        const tmpFile = ref([]);
        const errorFlg = ref(false);
        const openDialogHason = () => {
            dialogOpenHason.value = true;
        };
        const openDialogOther = () => {
            dialogOpenOther.value = true;
        };
        // 鍵返却日時
        const applyDateTime = updateKeyReturnDateTime;
        const isKeyReturnType = (row, ...types) => {
            const keyReturnNameKb = props.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === row.taikyoNo)?.keyReturnNameKb;
            return keyReturnNameKb !== undefined && keyReturnNameKb !== null && types.includes(keyReturnNameKb);
        };
        // 退去理由、連絡先、送付先
        const clearTaikyoRiyu = (taikyo) => {
            if (viewModel.isDisableTaikyoRiyu(taikyo)) {
                taikyo.taikyoRiyu = null;
            }
        };
        const clearRenrakuField = clearContactFields;
        const clearSoufuField = (row) => clearReturnAddressFields(row, myPageStore.personal);
        // ファイル操作
        const fileDelete = (file) => {
            file.delFlg = true;
        };
        const onFilePicked = async (value, row) => {
            errorFlg.value = false;
            const files = Array.isArray(value) ? value : [value];
            const msg = validateSelectedFiles(files, row);
            errorFlg.value = msg !== "";
            if (msg !== "") {
                await MsgBox.error(msg);
            }
        };
        async function uploadFile(files, row, fileKb) {
            const fileList = [];
            try {
                Loading.show();
                const currentFiles = Array.isArray(files) ? files : [files];
                currentFiles.forEach((file, index) => {
                    const attached = new AttachedFile();
                    const now = new Date();
                    const date = String(now.getFullYear()) +
                        String(now.getMonth() + 1).padStart(2, "0") +
                        String(now.getDate()).padStart(2, "0") +
                        String(now.getHours()).padStart(2, "0") +
                        String(now.getMinutes()).padStart(2, "0") +
                        String(now.getSeconds()).padStart(2, "0");
                    attached.fileId = String(row.taikyoNo) + date + String(index);
                    attached.fileKb = fileKb;
                    attached.fileName = file.name;
                    attached.newFlg = true;
                    row.fileList.push(attached);
                    fileList.push(attached);
                });
                row.files = Array.from(currentFiles);
                tmpFile.value = [];
                await store.insertFile(row.taikyoNo, currentFiles, fileList);
            }
            catch (ex) {
                // アップロードに失敗した場合、削除フラグにtrueをセット
                row.fileList
                    .filter(x => fileList.some(y => y.fileId === x.fileId))
                    .forEach(x => {
                    x.delFlg = true;
                });
                log.error("setup", ex);
                MsgBox.error(ex.message);
            }
            finally {
                Loading.hide();
                dialogOpenHason.value = false;
                dialogOpenOther.value = false;
            }
        }
        const remove = (orgNyukyokeiyakuNo) => {
            emit("remove", orgNyukyokeiyakuNo);
        };
        const findAddress = async (row) => {
            if (getValidator(row)?.data.error && getValidator(row)?.data.errorFields.includes("postCode")) {
                return;
            }
            //ハイフン対応
            if (row.postCode?.length === 7) {
                row.postCode = row.postCode.substring(0, 3) + "-" + row.postCode.substring(3);
            }
            try {
                if (/^\d{3}-\d{4}$/.test(row.postCode)) {
                    row.adr1 = await createAddress(row.postCode);
                }
            }
            catch (ex) {
                // 該当する住所が存在しない場合は404が投げられる
                if (ex?.status !== 404) {
                    log.error("findAddress", ex);
                }
            }
        };
        function runValid() {
            let hasError = false;
            validators.forEach(v => {
                if (v.error) {
                    hasError = true;
                }
            });
            return hasError;
        }
        expose({
            runValid
        });
        watch(() => props.row.taikyoYmd, () => {
            updateKaiyakuYmd(props.row);
        });
        return {
            props,
            $q,
            isMultipleKeiyaku,
            dayjs,
            isKeyReturnType,
            isMMA,
            viewModel,
            applyDateTime,
            remove,
            openDialogHason,
            dialogOpenHason,
            openDialogOther,
            dialogOpenOther,
            uploadFile,
            fileDelete,
            tmpFile,
            getValidator,
            clearSoufuField,
            clearRenrakuField,
            findAddress,
            TaikyoRiyuKb,
            RenrakuKb,
            KeyReturnNameKb,
            KeyReturnAdrKb,
            onFilePicked,
            errorFlg,
            clearTaikyoRiyu,
            desiredDateMessage,
            desiredDateEntryMessage
        };
    }
});
